<div class="modal-body text-center">
    @if (ticketIds) {
        <p translate>This action will change the queue. Do you want to continue?</p>
    } @else {
        <p>
            {{ 'This action will change the queue for' | translate }}
            @for (ticketId of ticketIds; track ticketId; let isLast = $last) {
                #<a [routerLink]="" [queryParams]="{ ticketId: ticketId }"
                    >{{ ticketId }}
                    @if (!isLast) {
                        ,&nbsp;
                    }
                </a>
            }
            . {{ 'Do you want to continue ?' | translate }}
        </p>
    }

    <label class="checkbox__label checkbox__label--size-small mt-3 mb-3">
        <span translate>Don’t show this message again</span>
        <input type="checkbox" name="isHideModal" [(ngModel)]="isDoNotShowModalAgain" />
        <span class="checkbox__checkmark"></span>
    </label>
    <div>
        <button type="button" class="btn btn-default" (click)="decline()" translate>Cancel</button>
        <button type="button" class="btn btn-primary ms-2" (click)="confirm()" translate>Yes</button>
    </div>
</div>
